import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Landing    from "./pages/Landing";
import Registro   from "./pages/Registro";
import Login      from "./pages/Login";
import Perfilado  from "./pages/Perfilado";
import Dashboard  from "./pages/Dashboard";
import Guia       from "./pages/Guia";
import Biblioteca from "./pages/Biblioteca";
import Perfil     from "./pages/Perfil";
import Comunidad  from "./pages/Comunidad";
import ForoTema   from "./pages/ForoTema";
import Verificar  from "./pages/Verificar";
import GoogleAuthSuccess from "./pages/GoogleAuthSuccess";
import Privacidad from "./pages/Privacidad";
import Terminos   from "./pages/Terminos";
import Checkout   from "./pages/Checkout";
import PagoExitoso from "./pages/PagoExitoso";
import CompletarPerfil from "./pages/CompletarPerfil";
import "./styles/globals.css";

/** Redirige a /dashboard si ya hay sesión activa */
function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <>{children}</>;
}

/** Redirige a /login si no hay sesión */
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/"          element={<PublicRoute><Landing /></PublicRoute>} />
      <Route path="/registro"  element={<PublicRoute><Registro /></PublicRoute>} />
      <Route path="/login"     element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/perfilado"        element={<PrivateRoute><Perfilado /></PrivateRoute>} />
      <Route path="/dashboard"        element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/biblioteca"          element={<PrivateRoute><Biblioteca /></PrivateRoute>} />
      <Route path="/perfil"             element={<PrivateRoute><Perfil /></PrivateRoute>} />
      <Route path="/guia/:categoria"    element={<Guia />} />
      <Route path="/comunidad"          element={<Comunidad />} />
      <Route path="/comunidad/:tema_id" element={<ForoTema />} />
      <Route path="/verificar"          element={<Verificar />} />
      <Route path="/auth/google/success" element={<GoogleAuthSuccess />} />
      <Route path="/privacidad"         element={<Privacidad />} />
      <Route path="/terminos"           element={<Terminos />} />
      <Route path="/checkout"           element={<Checkout />} />
      <Route path="/pago-exitoso"       element={<PrivateRoute><PagoExitoso /></PrivateRoute>} />
      <Route path="/completar-perfil"   element={<PrivateRoute><CompletarPerfil /></PrivateRoute>} />
      <Route path="*"                   element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
